import React from 'react';
import { View } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import {
  map as _map,
  isFunction as _isFunction,
  isNil as _isNil,
  groupBy as _groupBy,
} from 'lodash';
import PropTypes from 'prop-types';

import { ErrorScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';

import { PRODUCT_STATUS } from '../../Services/Enums';
import SohoFrameworkTestKeys from '../../Utils/SohoFrameworkTestKeys';

import PlanTitleLoading from './Components/PlanTitleLoading';
import { PlanWithExtrasModal } from './Containers';
import styles from './Plans.Styles';

function Plans({ ...props }) {
  const {
    plans,
    isLoading,
    error,
    onTryAgainPress,
    withTray,
    images,
    onViewPlanPress,
    onAddUsagePress,
    onAddUsageConfirmationPress,
    addExtraPlanData,
    onAddUsageClose,
    title,
    subTitle,
    onExtrasErrorPrimaryButtonPress,
    shouldShowAddUsageButton,
    isCurrencyFirst,
    ..._props
  } = props;
  const renderTitleLoading = () => {
    return <PlanTitleLoading />;
  };

  const renderPlan = plan => {
    const isInactivePlan = plan.status === PRODUCT_STATUS.TERMINATED;

    const getSubtitle = () => {
      if (subTitle) {
        return subTitle;
      }
      return plan.status === PRODUCT_STATUS.TERMINATED
        ? 'soho_plans_inactive_service_subtitle_text'
        : 'soho_plans_active_service_subtitle_text';
    };
    return (
      <>
        {isLoading && renderTitleLoading()}
        <PlanWithExtrasModal
          {...plan}
          title={title}
          // subTitle={getSubtitle()}
          isLoading={isLoading}
          images={images}
          onViewPlanPress={() => _isFunction(onViewPlanPress) && onViewPlanPress(plan)}
          onAddUsagePress={onAddUsagePress}
          addExtraPlanData={addExtraPlanData}
          onAddUsageClose={onAddUsageClose}
          onAddUsageConfirmationPress={onAddUsageConfirmationPress}
          planContainerStyle={styles.planContainerStyle}
          titleContainerStyle={styles.titleContainerStyle}
          usageValuesTextStyle={styles.usageValuesTextStyle}
          plansExtrasErrorScreenProps={{
            title: 'soho_extras_modal_error_screen_title',
            onPrimaryBtnPress: onExtrasErrorPrimaryButtonPress,
            primaryBtnTitle: 'soho_extras_modal_error_screen_primary_button_title',
          }}
          shouldShowAddUsageButton={!isInactivePlan && shouldShowAddUsageButton}
          isCurrencyFirst={isCurrencyFirst}
          {..._props}
        />
      </>
    );
  };

  const renderPlansGroup = group => {
    return _map(group, (plan, index) => {
      return renderPlan({
        ...plan,
        withPlanCardHeader: index === 0,
      });
    });
  };

  const renderPlans = () => {
    const groupedPlans = _groupBy(plans, plan => plan.status);
    return (
      <View style={styles.plansContainerStyle}>
        <View
          style={styles.planTitleContainerStyle}
          testID={SohoFrameworkTestKeys.PlanTitleContainer}
        >
          <VFText i18nKey={title} style={styles.planTitleTextStyle} />
        </View>

        {_map(groupedPlans, group => {
          return renderPlansGroup(group);
        })}
      </View>
    );
  };

  const renderError = () => {
    return (
      <>
        <View style={styles.errorTitleContainerStyle}>
          <VFText i18nKey={title} style={styles.planTitleTextStyle} />
        </View>
        <ErrorScreen
          iconStyle={styles.errorIconStyle}
          text={error?.message}
          {...error}
          onPress={onTryAgainPress}
          textButton={'soho_plans_failure_try_again'}
        />
      </>
    );
  };

  return (
    <View style={styles.containerStyle(withTray)}>
      {isLoading ? renderPlan({}) : !_isNil(error) ? renderError() : renderPlans()}
    </View>
  );
}

Plans.defaultProps = {
  title: 'soho_plans_section_title',
  withPriceVat: false,
  isCurrencyFirst: false,
};

Plans.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      serviceType: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
      users: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          role: PropTypes.string,
          name: PropTypes.string,
          '@type': PropTypes.string,
          '@referredType': PropTypes.string,
        }),
      ),
      unassignedUsers: PropTypes.arrayOf(
        PropTypes.shape({
          '@type': PropTypes.string,
          name: PropTypes.string,
          id: PropTypes.string,
          role: PropTypes.string,
        }),
      ),
      contractData: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.string,
          type: PropTypes.string,
        }),
      ),
      price: PropTypes.number,
      currency: PropTypes.string,
      usageData: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          usageType: PropTypes.string,
          icon: PropTypes.string,
          isUnlimited: PropTypes.bool,
          totalAmount: PropTypes.number,
          totalUnits: PropTypes.string,
          usedAmount: PropTypes.number,
          usedUnits: PropTypes.string,
          valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    }),
  ),
  isLoading: PropTypes.bool,
  shouldShowAddUsageButton: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  onTryAgainPress: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  withTray: PropTypes.bool,
  images: PropTypes.array,
  percentageIndicatorSecondaryColor: PropTypes.string,
  usageValuesTextStyle: TextPropTypes.style,
  numberToReview: PropTypes.number,
  onViewPlanPress: PropTypes.func,
  onAddUsagePress: PropTypes.func,
  onAddUsageConfirmationPress: PropTypes.func,
  addExtraPlanData: PropTypes.object,
  onAddUsageClose: PropTypes.func,
  onExtrasErrorPrimaryButtonPress: PropTypes.func,
  isCurrencyFirst: PropTypes.bool,
};

export default Plans;
